import axios, { AxiosRequestConfig } from 'axios'
import { Toast } from 'vant'
import { useUserStore } from '@/store/modules/user'
import { useHomeStoreWithOut } from '@/store/modules/home'
import { getWxOAuthPath } from '@/utils/common'
import { Storage } from '@/utils/Storage'
import { USER_FIRST_VISISIT_LINK } from '@/enums/cacheEnum'
import { whiteList } from '@/constant/requestFilter'
export interface RequestOptions {
  /** 是否直接获取data，而忽略message等 */
  isGetDataDirectly?: boolean
  /** 请求成功是提示信息 */
  successMsg?: string
  /** 请求失败是提示信息 */
  errorMsg?: string
  /** 是否mock数据请求 */
  isMock?: boolean
}

const homeStore = useHomeStoreWithOut()
const UNKNOWN_ERROR = '未知错误，请重试  '
/** 真实请求的路径前缀 */
// const baseApiUrl = process.env.VUE_APP_BASE_API

const service = axios.create({
  // baseURL: baseApiUrl,
  timeout: 30000,
})

service.interceptors.request.use(
  (config) => {
    homeStore.setLoading(true)
    const userStore = useUserStore()
    const token = userStore.token
    const userId = userStore.userId
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        token,
        userId,
      }
    } else {
      // post请求token需要携带在url中
      if ((config.url as string)?.indexOf('?') > 0) {
        config.url = `${config.url}&token=${token}&userId=${userId}`
      } else {
        config.url = `${config.url}?token=${token}&userId=${userId}`
      }
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    // 登录失效
    if (response.data.ret === 106) {
      const userStore = useUserStore()
      userStore.resetOAuth()
      // Storage.set(USER_FIRST_VISISIT_LINK, location.pathname)
      console.log('request state: 106', location.pathname)
      setTimeout(() => {
        location.href = getWxOAuthPath()
      }, 5e3)
      return false
    }
    if (response.data.ret !== 100) {
      const url = response.config.url || ''
      if (!whiteList.includes(url?.split('?')[0])) {
        Toast(response.data.msg)
      }
    }
    return response.data
  },
  (error) => {
    // 处理 422 或者 500 的错误异常提示
    const errMsg = error?.response?.data?.message ?? UNKNOWN_ERROR
    error.message = errMsg
    return Promise.reject(error)
  }
)

export type Response<T = any> = {
  code: number
  message: string
  data: T
}

export type BaseResponse<T = any> = Promise<Response<T>>

/**
 *
 * @param method - request methods
 * @param url - request url
 * @param data - request data or params
 */
export const request = async <T = any>(
  config: AxiosRequestConfig,
  options: RequestOptions = {}
): Promise<T> => {
  try {
    const { isGetDataDirectly = false } = options
    const fullUrl = '/webapi' + config.url
    // const reg = new RegExp('(?<!:)/{2,}', 'g')
    // // config.url = fullUrl.replace(/(?<!:)\/{2,}/g, '/')
    // console.log('config.url=>', config.url)
    // console.log('config.url==fullUrl=>', fullUrl)
    config.url = fullUrl
    // console.log('config.url===>', config.url)
    const res: any = await service.request(config)
    homeStore.setLoading(false)
    if (isGetDataDirectly) {
      Toast(res.msg || UNKNOWN_ERROR)
    }
    if (res.ret === -1 && !whiteList.includes(fullUrl?.split('?')[0] || '')) {
      Toast(res.msg)
    }
    return res
  } catch (error) {
    console.log('request==error==>', error)
    homeStore.setLoading(false)
    return Promise.reject(error)
  }
}
